/* tslint:disable */
/* eslint-disable */
/**
 * MinSide.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserMigrationMigrateRoleRequest } from './UserMigrationMigrateRoleRequest';
import {
    UserMigrationMigrateRoleRequestFromJSON,
    UserMigrationMigrateRoleRequestFromJSONTyped,
    UserMigrationMigrateRoleRequestToJSON,
    UserMigrationMigrateRoleRequestToJSONTyped,
} from './UserMigrationMigrateRoleRequest';

/**
 * 
 * @export
 * @interface UserMigrationMigrateRequest
 */
export interface UserMigrationMigrateRequest {
    /**
     * 
     * @type {string}
     * @memberof UserMigrationMigrateRequest
     */
    applicationId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserMigrationMigrateRequest
     */
    username?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserMigrationMigrateRequest
     */
    password?: string | null;
    /**
     * 
     * @type {Array<UserMigrationMigrateRoleRequest>}
     * @memberof UserMigrationMigrateRequest
     */
    roles?: Array<UserMigrationMigrateRoleRequest> | null;
}

/**
 * Check if a given object implements the UserMigrationMigrateRequest interface.
 */
export function instanceOfUserMigrationMigrateRequest(value: object): value is UserMigrationMigrateRequest {
    return true;
}

export function UserMigrationMigrateRequestFromJSON(json: any): UserMigrationMigrateRequest {
    return UserMigrationMigrateRequestFromJSONTyped(json, false);
}

export function UserMigrationMigrateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserMigrationMigrateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'applicationId': json['applicationId'] === undefined ? undefined : json['applicationId'] === null ? null : json['applicationId'],
        'username': json['username'] === undefined ? undefined : json['username'] === null ? null : json['username'],
        'password': json['password'] === undefined ? undefined : json['password'] === null ? null : json['password'],
        'roles': json['roles'] === undefined ? undefined : json['roles'] === null ? null : ((json['roles'] as Array<any>).map(UserMigrationMigrateRoleRequestFromJSON)),
    };
}

export function UserMigrationMigrateRequestToJSON(json: any): UserMigrationMigrateRequest {
    return UserMigrationMigrateRequestToJSONTyped(json, false);
}

export function UserMigrationMigrateRequestToJSONTyped(value?: UserMigrationMigrateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'applicationId': value['applicationId'],
        'username': value['username'],
        'password': value['password'],
        'roles': value['roles'] == null ? undefined : ((value['roles'] as Array<any>).map(UserMigrationMigrateRoleRequestToJSON)),
    };
}

